import { NgZone, OnInit, Component } from '@angular/core';
import { Router } from '@angular/router';
import { } from 'googlemaps';
import { User } from '../_models/index';
import { CookieService, MyCartService } from '../_services/index';

declare var $: any;

@Component({
    moduleId: module.id,
    templateUrl: 'mycart.component.html',
    styleUrls: ['mycart.component.css']
})
export class MycartComponent implements OnInit {
    currentUser: User;
    users: User[] = [];
    username = "Username";
    customerId: any;
    sessionKey: string;
    orderConfirmation: string;
    cartData: any = [];
    savedOrder: any;
    constructor(private ngZone: NgZone, private router: Router, private cookieService: CookieService, private myCartService: MyCartService) {
        if (this.cookieService.getCookie('customerName')) {
            this.username = this.cookieService.getCookie('customerName');
        }

        if (this.cookieService.getCookie('customerID') && (this.cookieService.getCookie("sessionKey"))) {
            this.customerId = this.cookieService.getCookie('customerID');
            this.sessionKey = this.cookieService.getCookie("sessionKey");
            this.LoadMyCart(this.customerId, this.sessionKey);
        }
    }

    LoadMyCart(customerId: string, skey: string) {
        this.myCartService.getcart(customerId, skey).subscribe(
            data => {
                this.cartData = data;
                this.ngZone.run(() => {
                    setTimeout(function () {
                        $(function () {
                            $('#data-table').DataTable();
                            let table = $('#data-table').DataTable();

                            table
                                .order([3, 'desc'])
                                .draw();
                        });
                    }, 10)
                })
            }
        )
    }

    setDelay(customerId: string, orderid: string, delayed: string, skey: string) {
        this.myCartService.setdelay(customerId, orderid, delayed, skey).subscribe(result => console.log(result),
            error => this.orderConfirmation = error);
    }

    deleteOrder(customerId: string, orderId: string, skey: string) {
        this.myCartService.removeorder(customerId, orderId, skey).subscribe(result => console.log(result),
            error => this.orderConfirmation = error);
    }

    getsingleOrder(customerId: string, orderId: string, skey: string) {
        this.myCartService.getsingleOrder(customerId, orderId, skey).subscribe(result => {
            this.cookieService.setCookieSession("savedOrder", JSON.stringify(result));
            if (this.cookieService.getCookie('savedOrder')) {
                let orderInfo = JSON.parse(this.cookieService.getCookie('savedOrder'));
                this.cookieService.setCookieSession("OrderID", orderInfo.order_id);
                //====
                this.cookieService.setCookieSession('DataSources', JSON.stringify(orderInfo.data_sources));
                let centerLatlng: any;
                if (orderInfo.geometry.indexOf("|") != -1) {
                    let geomstring = "[" + (orderInfo.geometry).replace(/\|/g, ',') + "]";
                    this.cookieService.setCookieSession('selectedGeometry', geomstring);
                    let orderGeo = JSON.parse(geomstring);
                    centerLatlng = { lat: parseFloat(orderGeo[0][0][0][1]), lng: parseFloat(orderGeo[0][0][0][0]) };
                } else {
                    this.cookieService.setCookieSession('selectedGeometry', orderInfo.geometry);
                    let orderGeo = JSON.parse(orderInfo.geometry);
                    centerLatlng = { lat: parseFloat(orderGeo[0][0][1]), lng: parseFloat(orderGeo[0][0][0]) };
                }
                this.cookieService.setCookieSession('geoType', orderInfo.geometry_type);
                let savedAddress = orderInfo.address1 + " , " + orderInfo.city + " , " + orderInfo.provstate + " , " + orderInfo.postalzip + " , " + orderInfo.country;
                this.cookieService.setCookieSession("address", savedAddress);
                this.cookieService.setCookieSession("country", orderInfo.country);
                this.cookieService.setCookieSession("ProvState", orderInfo.provstate);
                this.cookieService.setCookieSession("homeZome", 16);
                this.cookieService.setCookieSession('Center', JSON.stringify(centerLatlng));
                this.cookieService.setCookieSession("PName", orderInfo.site_name);
                this.cookieService.setCookieSession("PONumber", orderInfo.project_num);
                let options = [
                    orderInfo.project_num,
                    orderInfo.lot_building_size,
                    orderInfo.lot,
                    orderInfo.concession,
                    orderInfo.municipality,
                    orderInfo.legal_description,
                    orderInfo.municipality,
                    orderInfo.current_occupants,
                    orderInfo.past_occupants,
                    orderInfo.special_instructions,
                    orderInfo.alternate_email,
                ];
                this.cookieService.setCookieSession("optionInfo", JSON.stringify(options));
            }
            this.ngZone.run(() => {
                this.router.navigateByUrl('/package');
            })
        },
            error => this.orderConfirmation = error);
    }

    ngOnInit() {
        // to be implemented
    }

    addOrderStatus(id: string, event) {
        let delayed = "";
        if ((event.target).checked) {

            delayed = "Y";
        } else {
            delayed = "N";
        }
        this.setDelay(this.customerId, id, delayed, this.sessionKey);
    }

    removeOrder(id: string): void {
        this.deleteOrder(this.customerId, id, this.sessionKey);
        this.ngZone.run(() => {
            this.router.navigateByUrl('/mycart');
        })
    }

    continueOrder(): void {
        this.cookieService.clearAll();
    }

    editOrder(id: string): void {
        this.cookieService.clearAll();
        this.getsingleOrder(this.customerId, id, this.sessionKey);
    }
}